// Detects Android TV / leanback environment and bootstraps TV mode.

export function isTVEnvironment() {
  const ua = navigator.userAgent || '';
  // Capacitor on Android TV sets this UA fragment; also catches Fire TV
  return (
    /Android/.test(ua) &&
    (/TV|AFTM|AFTB|AFTT|AFTRS|AFTS|AFT/.test(ua) ||
      window.matchMedia('(pointer: none)').matches)
  );
}

// Call once at app startup. Adds `tv-mode` class to <html> so CSS can target it.
export function initTVMode() {
  if (isTVEnvironment()) {
    document.documentElement.classList.add('tv-mode');
  }
}

// D-pad key codes
export const DPAD = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
  SELECT: 'Enter',
  BACK: 'Escape',
  PLAY_PAUSE: ' ',         // Space bar / some remotes
  MEDIA_PLAY_PAUSE: 'MediaPlayPause',
  MEDIA_REWIND: 'MediaRewind',
  MEDIA_FAST_FORWARD: 'MediaFastForward',
  CHANNEL_UP: 'ChannelUp',
  CHANNEL_DOWN: 'ChannelDown',
};

// Hook: returns true if running in TV mode (reads the html class set by initTVMode)
export function useTVMode() {
  return document.documentElement.classList.contains('tv-mode');
}
